import { useParams } from 'react-router-dom';
import { all } from '../data/all';

function CountriesByContinent() {
    const { continent } = useParams();

    let continentData = [];
    
    all.forEach(thisCountry => {
        if (thisCountry.region === continent)
            continentData = [...continentData, thisCountry];
    })

    continentData.sort(function(a, b) {
        return a.name.common > b.name.common;
    });

    return (
        <code>
            { JSON.stringify(continentData) }
        </code>
    )
}

export default CountriesByContinent;